import { html } from "uhtml";
import { CustomisedWithDialog } from "../custom-element.js";
import { locale, pageNumber } from "../../view-models/app-signals.js";
import { pageCount } from "../../view-models/page-signals.js";
import { locales } from "../../models/locales.js";
import { pdfOutline } from "../../view-models/book-signals.js";
import { pdfOutlineTree } from "../partials/pdfOutlineTree.js";
import "./cassis-bookmark.js";
import { closeIcon } from "./close-icon.js";

export class CassisContents extends CustomisedWithDialog(HTMLElement) {
	static tagName = "cassis-contents";
	handleToggle(event) {
		const button = event.target;
		if (!button.matches("[aria-selected='true']")) {
			const otherButton = this.querySelector("button[aria-selected='true']");
			otherButton.setAttribute("aria-selected", "false");
			button.setAttribute("aria-selected", "true");
			document
				.getElementById(button.getAttribute("aria-controls"))
				.classList.add("active");
			document
				.getElementById(button.getAttribute("aria-controls"))
				.classList.remove("inactive");
			document
				.getElementById(otherButton.getAttribute("aria-controls"))
				.classList.remove("active");
			document
				.getElementById(otherButton.getAttribute("aria-controls"))
				.classList.add("inactive");
		}
	}
	signals() {
		const currentPage = pageNumber();
		const count = pageCount();
		const outline = pdfOutline();
		return { currentPage, pageCount: count, locale: locale(), outline };
	}
	render({ currentPage, pageCount, locale, outline }) {
		this.currentPage = currentPage;
		this.pageCount = pageCount;
		return html`
			<button class="contents" data-type="open-dialog">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19 19" preserveAspectRatio="xMidYMid meet" role="img" class="icon open" aria-labelledby="toc-icon">
  <title id="toc-icon">${locales.contents[locale]}</title>
  <path d="M3.039 1.241A2.182 2.182 0 0 0 .86 3.42c0 1.202.978 2.179 2.179 2.179s2.178-.977 2.178-2.179-.977-2.179-2.178-2.179zm0 3.746A1.569 1.569 0 0 1 1.472 3.42c0-.864.703-1.567 1.567-1.567s1.567.703 1.567 1.567-.703 1.567-1.567 1.567z"></path><path d="M17.834 3.114H7.444a.307.307 0 0 0 0 .612h10.39a.306.306 0 1 0 0-.612z"></path><path d="M3.039 7.421A2.181 2.181 0 0 0 .86 9.6c0 1.201.978 2.179 2.179 2.179s2.178-.978 2.178-2.179a2.181 2.181 0 0 0-2.178-2.179zm0 3.746A1.569 1.569 0 0 1 1.472 9.6c0-.864.703-1.567 1.567-1.567a1.568 1.568 0 0 1 0 3.134z"></path><path d="M17.834 9.294H7.444a.307.307 0 0 0 0 .612h10.39c.169 0 .307-.137.307-.306s-.138-.306-.307-.306z"></path><path d="M3.039 13.602c-1.201 0-2.179.979-2.179 2.18s.978 2.179 2.179 2.179 2.178-.978 2.178-2.179a2.18 2.18 0 0 0-2.178-2.18zm0 3.746a1.568 1.568 0 0 1-1.567-1.565c0-.865.703-1.568 1.567-1.568s1.567.703 1.567 1.568a1.57 1.57 0 0 1-1.567 1.565z"></path><path d="M17.834 15.475H7.444a.307.307 0 0 0 0 .613h10.39a.306.306 0 1 0 0-.613z"></path>
</svg>
${closeIcon()}
<span class="setting-text contents" id="contents-label">${locales.contents[locale]}</span>
          </button>

          <dialog closedby="any" autofocus @click=${(event) => {
						if (event.target.matches("a")) {
							this.dialogClose();
						}
					}} class="contents-view controls-view active">
            <div class="tabs-list" role="tablist" aria-label="Tabs">
              <button class="tab" role="tab" aria-selected="true" aria-controls="toc-view" id="toc-tab" @click="${(event) => this.handleToggle(event)}">${locales.toc[locale]}</button>
              <button class="tab" role="tab" aria-selected="false" aria-controls="bookmarks-view" id="bookmarks-tab" @click="${(event) => this.handleToggle(event)}">${locales.bookmarks[locale]}</button>
            </div>
            <div class="toc-view" role="tabpanel" id="toc-view" aria-labelledby="toc-tab">${pdfOutlineTree(outline)}</div>

            <jb-close-button class="about-this-book">

            <button
              type="button"
              data-type="close-dialog"
              tabindex="0"
            >
              ${locales.closeIcon[locale]}
            </button>
            </jb-close-button>
<cassis-bookmarks-list class="bookmarks-view inactive" role="tabpanel" id="bookmarks-view" aria-labelledby="bookmarks-tab"></cassis-bookmarks-list>
          </dialog>`;
	}
}
CassisContents.define();
